import { css } from "emotion";
import H1 from "../../../../components/global/H1";
import H4 from "../../../../components/global/H4";
import P from "../../../../components/global/P";
import ColorServices from "../../../../services/ColorServices";
import { max } from "../../../../utils/CssUtils";

const purple = ColorServices.getColor("purpleMid");

const wrapper = css({
  position: "relative",
  backgroundColor: ColorServices.getColor("greyPurpleBackground"),
  padding: "62px 70px",
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  [max(750)]: {
    padding: "20px 14px 18px 14px"
  }
});

const block = css({
  textAlign: "center",
  minWidth: 320,
  margin: 10,
  [max(750)]: {
    marginBottom: 12
  },
  h4: {
    marginBottom: 10,
    [max(750)]: {
      marginBottom: 8
    }
  },
  h1: {
    marginBottom: 10,
    fontWeight: 700,
    [max(750)]: {
      marginBottom: 8
    }
  }
});

const OurImpact = ({ data = [] }) => {
  return (
    <div className={wrapper}>
      {data.map(item => (
        <div className={block}>
          <H4 color={purple}>{item.title}</H4>
          <H1 color={purple}>{item.content}</H1>
          <P color={purple}>{item.subtext}</P>
        </div>
      ))}
    </div>
  );
};

export default OurImpact;
